/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Phone2Inputs */

const en_clients_field_phone2 = /** @type {(inputs: Clients_Field_Phone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone 2`)
};

const pt_br2_clients_field_phone2 = /** @type {(inputs: Clients_Field_Phone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefone 2`)
};

/**
* | output |
* | --- |
* | "Phone 2" |
*
* @param {Clients_Field_Phone2Inputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_phone2 = /** @type {((inputs?: Clients_Field_Phone2Inputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Phone2Inputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_phone2(inputs)
	return pt_br2_clients_field_phone2(inputs)
});